import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollCalculation  {
    _originalTypeClassName = "zERP.BO.PayrollCalculation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollCalculation.translate = translateService;
}
this.Employees = [];
this.Id = null;
this.FMY = null;
this.FMYRegular = null;
this.PayableAmount = null;
this.AdvanceAmount = null;
this.OvertimesFrom = null;
this.OvertimesTo = null;
this.LeavesFrom = null;
this.LeavesTo = null;
this.EAPIncomeType = null;
this.CancelNegativeTax = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FMY:any;
FMYRegular:any;
PayableAmount:any;
AdvanceAmount:any;
OvertimesFrom:any;
OvertimesTo:any;
LeavesFrom:any;
LeavesTo:any;
EAPIncomeType:any;
CancelNegativeTax:any;
Employees:any;
Payroll:any;
Type:any;
Period:any;
APDFileExport:any;
PayrollEapXMLFileExport:any;
static setEmployees = ($this, items) => {
                if (items == null) items = [];
                if ($this.Employees == null) $this.Employees = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Employees.length > 0) {
                    Domain.PayrollCalculation.removeEmployees($this, $this.Employees[0]);
                }

                Domain.PayrollCalculation.addManyEmployees($this, copyItems);
            }
static addManyEmployees = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollCalculation.addEmployees($this, items[i]);
                }
            }
static addEmployees = ($this, item) => {
                if ($this.Employees == null) $this.Employees = [];
                if (item == null || $this.Employees.indexOf(item) > -1) return;
                $this.Employees.push(item);
if (item.PayrollCalculation != $this) {
Domain.EmployeePayroll.setPayrollCalculation(item, $this);
}
}
static addRangeEmployees = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollCalculation.addEmployees($this, item));
            }
static removeEmployees = ($this, item) => {
                if ($this == null || $this.Employees == null || $this.Employees.indexOf(item) === -1) return;
                var _index = $this.Employees.indexOf(item);
                $this.Employees.splice(_index, 1);
item.PayrollCalculation = null;
}
static clearEmployees = ($this) => { $this.Employees = null; }
static setPayroll = ($this, value) => {
var oldValue = $this.Payroll;
$this.Payroll = value;
if (value != null) {
if (oldValue != null) {
Domain.Payroll.removeCalculations(oldValue, $this);
}
Domain.Payroll.addCalculations(value, $this);
}
}
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setPeriod = ($this, value) => {
var oldValue = $this.Period;
$this.Period = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollPeriod.removeCalculations(oldValue, $this);
}
Domain.PayrollPeriod.addCalculations(value, $this);
}
}
static setAPDFileExport = ($this, value) => {
var oldValue = $this.APDFileExport;
$this.APDFileExport = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollAPDFileExport.removePayrollCalculations(oldValue, $this);
}
Domain.PayrollAPDFileExport.addPayrollCalculations(value, $this);
}
}
static setPayrollEapXMLFileExport = ($this, value) => {
var oldValue = $this.PayrollEapXMLFileExport;
$this.PayrollEapXMLFileExport = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollEapXMLFileExport.removePayrollCalculations(oldValue, $this);
}
Domain.PayrollEapXMLFileExport.addPayrollCalculations(value, $this);
}
}

static GetPeriodDateTo($this: any): any{return $this?.Period?.To;
}
static UpdateTotals($this: any): any{$this.FMY = $this?.Employees?.linq?.sum((e) => e?.Tax);
$this.FMYRegular = $this?.Employees?.linq?.sum((e) => e?.RegularTax);
$this.PayableAmount = $this?.Employees?.linq?.sum((e) => e?.PayableAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}